import LegalPageLayout from "@/components/LegalPageLayout";

const H = ({ children }) => (
  <h2 className="mt-8 font-serif text-2xl text-navy">{children}</h2>
);

export default function Disclaimer() {
  return (
    <LegalPageLayout
      eyebrow="Legal"
      title="Disclaimer"
      lastUpdated="February 2026"
      testId="disclaimer-page"
    >
      <p>
        Please read this disclaimer carefully before relying on any document
        generated through WillSeva.
      </p>

      <H>Documents Are User-Generated</H>
      <p>
        Documents generated through the platform are based entirely on the
        information you provide. The accuracy and completeness of the resulting
        document depend on the accuracy of your inputs.
      </p>

      <H>Proper Execution Is Essential</H>
      <p>
        Legal validity of a will depends on proper execution under applicable Indian
        law — including signing by the testator and attestation by two competent
        witnesses who are not beneficiaries. Failure to execute the document
        correctly may render it invalid.
      </p>

      <H>Complex Estates</H>
      <p>
        Estates involving foreign assets, business interests, trusts, contested
        property or other complex arrangements may require customised legal advice
        beyond the scope of a template-driven service.
      </p>

      <H>No Guarantee of Outcome</H>
      <p>
        WillSeva does not guarantee probate approval, court acceptance, or any
        specific outcome in litigation, registration, taxation, or family dispute
        resolution.
      </p>

      <H>No Attorney-Client Relationship</H>
      <p>
        Use of the platform does not, by itself, create an attorney-client
        relationship between you and WillSeva or any of its associated lawyers. Such
        a relationship is created only when a Lawyer Review is separately purchased
        and the scope is mutually confirmed in writing.
      </p>

      <H>Periodic Updates Recommended</H>
      <p>
        Wills should be reviewed and updated periodically — particularly after
        major life events such as marriage, divorce, childbirth, property purchase,
        business changes, or significant changes in personal circumstances.
      </p>
    </LegalPageLayout>
  );
}
